import { createMachine, assign } from 'xstate';

import { stepHasTargetElement, stepHasCommand, passesPinnedElement, passesCommandCheck } from './selectors';

import type { EngineState } from '../state';
import type { NudgeContext } from './nudgeMachine';

type StepConditionsEvents = { type: 'PASSED_COMMAND_CHECK' } | { type: 'PASSED_TARGET_ELEMENT' };

type StepConditionsContext = { stepChecksFailed: boolean };

const StepConditionsMachine = (
  _: EngineState,
  {
    nudge,
    stepIndex,
    triggerEvent,
  }: { nudge: NudgeContext['nudge']; triggerEvent: NudgeContext['triggerEvent']; stepIndex: NudgeContext['stepIndex'] },
) =>
  createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QGUAuYAOACAwgewDsIBLVYw2AOhwAswBjAa2IKl0JLIoGIJCxKsVAEN0lNJnZFS5AlVoNmrKZ1mwA2gAYAuolAY8sGYT0gAHogCcARk2UAbAA4A7AGYATM9sAWa5fuWADQgAJ6IrpaOlJqu9q6uAKxeHs6aCQC+6cES2PjSXHLUdEwsbHmqFJQAMnh4SmwAYngATlgAKsLNMKhYAKIANmAAtmAEqJQACqMkrNxaukggBkYFphYIALTudt6Wlq6a3s6OaZZpccFhCI6ulAmWx+6u3mlP1t7umdnouRzGhQoSspyv8qDU6qUsE1Wh0umAegNhqNxlNpLN1NYFvpDP81uF3FFNM53AlYv5EtYLqFEDc7g9HE8Xgk3h8viAcipQUVFJCQQUwbV6lCWu1Ot0+oMRmNxGBOvQaJDoaK4QjJcjuBMAILIZC9AAiAH02pqAEoAcV6bQNvSqvQAsr0AHJteamZa4xbrTzOSiObz3eyk97WJLubyXcLWW6aInOB7uBPM+zWNkcvlqblAsp-fnVQWKkWw8WIqXjZCy5rygswsXwiVIsbcMxCUQCYQAM3QzQAFDb7U6rbrTTgABJGgCSDoA8gBVNoASm4aZzGcBQvTlXBQqVRbrJeRMrlCuUO9rqobqFdi3dq09iE8twJbgC9nc1kcjgCEYQ7+8lEsTIfJoNxRgkjgZFk7I-JyuZrryK6VHBwJ4EMQzCEQWCagAbsIxD9MIABGeGkCEkzTKUcw6G6OK3qA6wbPYDj2MSjgPLYNjAfs372Jolh3NY76OH4lj3AkASptBG4AsU64IdJPLIah6EQJhOF4YRxGoKRqIzFAcyYtRKyyHiCAeISxIJD4H5OJ43G8fxgnCaJzgSZIUnyDJ8H5KunmKWhGHYbh+FEf0JGZrJSlEBq2q6oaOBTnadqao6cUjr0OAANJXtiRkmHeCCeAk0SWNsybWM49gvJS34uFEsRgSJQlpC5kHLt5iG+dm7XyVm7CRSpgXqSFYVIdm-VNi2Ygdl23bxYlyWpelGUTtOc6Lm1FQ9bJ3UeQpY3+QNanBZppGjX1B3ZUsNHGflnjuJQiSuMczhiWBzjePY35uH+70VWBrjWGGSSWJkkEEHgEBwKYG2goZHp0YgGx+IxFUft4VXEpEwHfhsLx-mGTwie9Im+O9rm-Dt4VeZt8DXtdeUI5s7xRKjfoY+4WOODjAMox8ESkjGUYPOTME+XtoubvmJ6Fme9alnDtHmIjfqUBzCZ+hzFWUvcOMuKrfP7N4rHlTY3gi+5VPIZTW7VsqxZqtKOmlArN2My8vrlbxTWJs4cbfnYJIvZ+rEA24Hi-ubcm7b1Fs29LNYqnLB7lketu7ue8t07lBAmRssSqyVBIfA8yaBkE1I-gy-7lYDiQxC8Zxm61klR5bXU03mELx3be4O+Mjp4D3GfIi7DNKwgCRgUxlKA6k+wA+GFcnMVjwRPEmhOGBkeU2dsdS40MuJ-u0rHz0TQAK5EKPOf5Uk1gOO+PEnAkRv+q434A-fL2+0bYbPDY8Rt4d13q3OOB8E72wvJQU+WAU6VhoFCIKkBr4mTErcSkAE3xvliIcdw353z3T8GkUkPEALMg-EArkICd6dXOspVSQUNKhS0ig-KSMYyUFZujTQ5UOYnC5hXD491nyvmIQvJILVvhuVbtQ4BtD8D9QYUNE6ZE0RQFYW7OwQlUh+k-K-Xi5criWQDrEHivFEi7AZBBKRFM5HiwtiAxRg1jrMNOvIlCB0NHjw2MyThTg2Y8Mxvwr6HhOEE3sKIl6lVJFQWkTQ+xMj3FOKOkwsKA86FXyzvDceSRGI4JuADEqxJvDvwrjxRiPD3xiUOKxcplDYLuPiTHDx9DnGpK0tQFpAUUkEUGF49Yk9bipH9AEcCzJLKGJpL7SgAlRKYIiRVew9SxbNKaRFA6SiXEjS6SpNciC8LIKyYrAZSQHD+geDYfw7gAh4Irm4e+ewtZxGuZVTwyzKh6n4P0xAPg+KWUBkkP0G9tgCKuPzVWn5njEn5i4JumQgA */
      id: 'Step Conditions',
      context: { stepChecksFailed: false },
      initial: 'Checking Conditions',
      states: {
        'Checking Conditions': {
          description:
            "It's possible for an individual step to have up to 2 conditions we need to check for. These checks are async and it's possible for either of them to fail. If both checks pass, or are not applicable, then we will advance to the next state. If either one fails, then we will not show the step. Because either failure aborts the whole transition, we run these checks in parallel.",

          states: {
            'Looking For Target Element': {
              initial: 'Pending',
              states: {
                Pending: {
                  always: [
                    {
                      target: 'Searching For Target Element',
                      cond: 'stepHasTargetElement',
                    },
                    {
                      target: 'No Target Element',
                    },
                  ],
                },

                'Searching For Target Element': {
                  invoke: {
                    src: 'searchForElement',
                  },

                  on: {
                    PASSED_TARGET_ELEMENT: {
                      target: 'Element Found',
                    },
                  },

                  after: {
                    ELEMENT_SEARCH_TIMEOUT: {
                      target: 'Element Search Failed',
                    },
                  },
                },

                'No Target Element': {
                  type: 'final',
                },

                'Element Found': {
                  type: 'final',
                },

                'Element Search Failed': {
                  type: 'final',
                  entry: ['sendFailure'],
                },
              },
            },
            'Checking Command Availability': {
              initial: 'Pending',

              states: {
                Pending: {
                  always: [
                    {
                      target: 'Checking Command',
                      cond: 'stepHasCommand',
                    },
                    {
                      target: 'No Command',
                    },
                  ],
                },

                'Checking Command': {
                  invoke: {
                    src: 'checkCommandAvailability',
                  },

                  on: {
                    PASSED_COMMAND_CHECK: {
                      target: 'Command Available',
                    },
                  },

                  after: {
                    COMMAND_CHECK_TIMEOUT: {
                      target: 'Command Check Failed',
                    },
                  },
                },

                'No Command': {
                  type: 'final',
                },

                'Command Available': {
                  type: 'final',
                },

                'Command Check Failed': {
                  type: 'final',
                  entry: ['sendFailure'],
                },
              },
            },
          },

          type: 'parallel',
          onDone: 'Done',
        },

        Done: {
          type: 'final',
          data: {
            stepChecksFailed: ({ stepChecksFailed }: StepConditionsContext) => stepChecksFailed,
          },
        },
      },
      schema: { events: {} as StepConditionsEvents, context: {} as StepConditionsContext },
      predictableActionArguments: true,
      preserveActionOrder: true,
      tsTypes: {} as import('./nudgeStepMachine.typegen').Typegen0,
    },
    {
      actions: {
        sendFailure: assign({ stepChecksFailed: true }),
      },
      services: {
        checkCommandAvailability: () => (callback) => {
          let canceled = false;

          (async () => {
            while (!canceled) {
              if (await passesCommandCheck(_, nudge, stepIndex)) callback('PASSED_COMMAND_CHECK');

              await new Promise((resolve) => setTimeout(resolve, 100));
            }
          })();

          return () => {
            canceled = true;
          };
        },
        searchForElement: () => (callback) => {
          const interval = setInterval(() => {
            if (passesPinnedElement(_, nudge, stepIndex)) {
              callback('PASSED_TARGET_ELEMENT');
            }
          }, 100);

          return () => {
            clearInterval(interval);
          };
        },
      },
      guards: {
        stepHasTargetElement: () => triggerEvent?.overrides?.pinnedElement || stepHasTargetElement(nudge, stepIndex),
        stepHasCommand: () => triggerEvent?.overrides?.ctaAction || stepHasCommand(nudge, stepIndex),
      },
      delays: { ELEMENT_SEARCH_TIMEOUT: 5000, COMMAND_CHECK_TIMEOUT: 500 },
    },
  );

export default StepConditionsMachine;
